<template>
    <div id="xxDetail">
        <top :title="title"></top>
        <div class="setFix"></div>
        <form action="">
            <mt-field label="姓名" class="addTag" v-model="userCard.name" :disabled="isDisable?true:false"></mt-field>
            <mt-field label="手机号" class="addTag" type="tel" v-model="userCard.mobile" :disabled="true"></mt-field>
            <mt-field label="身份证号" class="addTag" type="card" v-model="userCard.card" :disabled="isDisable?true:false"></mt-field>
            <div class="rowItem rowItem1 sfRow">
                <span class="name">身份<i class="red">*</i></span> 
                <mt-radio class="radios"
                v-model="userCard.owner"
                @change="chioceVal"
                :options="options">
                </mt-radio>
            </div>
            <div class="rowItem" v-if="userCard.owner=='租户'"  @click="chioceTime">
                租期截止日期<i>*</i> <span>{{userCard.expire_time}}</span>
            </div>
            <mt-field label="公司名称" v-if="userCard.owner=='公司'" class="addTag" placeholder="请输入公司名称" type="text" :disabled="isDisable?true:false" v-model="userCard.company"></mt-field>
            <mt-field label="事由" v-if="userCard.owner=='访客'" class="addTag" placeholder="请输入事由" type="text" v-model="userCard.other" :disabled="isDisable?true:false"></mt-field>
            <!-- <div class="rowItem" v-if="allow!=''" @click="chioceBuild">
                楼号<i>*</i> <span>{{userCard.No}}</span>
            </div> -->
            <mt-field label="住址" type="textarea" rows="2" class="addTag adarea" v-model="userCard.address" :disabled="isDisable?true:false"></mt-field>
            <!-- 是否十四天内返京 -->
            <div class="rowItem rowItem1">
                <span class="name">是否十四天内返京<i class="red">*</i></span> 
                <mt-radio class="radios"
                v-model="isYes"
                @change="chioceVal2"
                disabled=""
                :options="options2">
                </mt-radio>
            </div>
            <div class="bacKShow" v-if="showbackBox">
                <div class="rowItem"  @click="chioceTime2">
                    返京日期<i>*</i> <span>{{userCard.return_date}}</span>
                </div>
                <mt-field label="从何地返京" class="addTag" placeholder="如湖北武汉" :disabled="isDisable?true:false" type="ornot" v-model="userCard.wuhan"></mt-field>
                <div class="rowItem" style="border-bottom:0;"  @click="test">
                    返程交通工具 <span>{{userCard.vehicle}}</span>
                </div>
                <mt-field label="备注" placeholder="请填写航班号或车次" type="remark" :disabled="isDisable?true:false" v-model="userCard.backup"></mt-field>
            </div>
            <mt-field label="状态" type="states" v-model="userCard.status=='1'?'已通过':'待审核'" disabled="disabled"></mt-field>
        </form>
        <!-- 选择返京日期 -->
        <mt-datetime-picker
            ref="picker2"
            type="date"
            :startDate="startDateval2"
            :endDate="endDate2"
            v-model="pickerValue2"
            @confirm="getTimeval2">
        </mt-datetime-picker>
        <!-- 选择租赁截止日期 -->
        <mt-datetime-picker
            ref="picker"
            type="date"
            :startDate="startDateval"
            :endDate="endDateval"
            v-model="pickerValue"
            @confirm="getTimeval">
        </mt-datetime-picker>
        <!-- 选择楼号 -->
        <transition name="slide-fade">
            <div v-if="showBuild" class="chiceBox">
                <div class="innerBox">
                    <mt-picker :slots="buildslots" @change="onValuesChange2"></mt-picker>
                    <div class="btns">
                        <a href="javascript:;" @click="cancle2">取消</a>
                        <a href="javascript:;" class="sure" @click="sure2">确定</a>
                    </div>
                </div>
            </div>
        </transition>
        <!-- 选择交通工具 -->
        <transition name="slide-fade">
            <div v-if="showBtm" class="chiceBox">
                <div class="innerBox">
                    <mt-picker :slots="slots" @change="onValuesChange"></mt-picker>
                    <div class="btns">
                        <a href="javascript:;" @click="cancle">取消</a>
                        <a href="javascript:;" class="sure" @click="sure">确定</a>
                    </div>
                </div>
            </div>
        </transition>
        <div class="setH"></div>
        <!-- 审核只有管理员查看的时候显示 -->
        <div v-if="type!='user'&&userCard.status=='0'">
             <!-- v-if="type!='user'&&userCard.status=='0'" -->
            <mt-button type="danger" class="submitBtn ssubmitBtn" @click="regSubmit">退回修改</mt-button>
            <mt-button type="danger" class="submitBtn dsubmitBtn" @click="submitForm">通过审核</mt-button>
        </div>
        <mt-button type="danger" v-if="(type=='user'&&userCard.status=='-1') || (type=='user'&&isDone)" class="submitBtn" style="width:90%;" @click="changeSubmit">提交</mt-button>
        <mt-button v-if="type!='user'&&userCard.status=='1'" type="danger" class="submitBtn cxBtn" style="width:90%;" @click="cxSubmit">撤销此通行证</mt-button>
    </div>
</template>
<script>
import axios from "axios";
import Top from "@/component/top/top";
import { MessageBox, Toast } from 'mint-ui';
import moment from 'moment'
export default {
    components:{
        Top
    },
    data() {
        return {
            isYes:'',
            pickerValue2:'',
            showbackBox:false,
            startDateval2:moment().subtract(14, 'days').toDate(),
            endDateval:moment().add(3, 'years').toDate(),
            endDate2: new Date(),
            startDateval:new Date(),
            title:'',
            showBtm:false,
            showBuild:false,
            value:'123',
            shShow:false,
            type:this.$route.query.type,
            isDisable:true,
            allow:'',
            pickerValue:'',
            slots: [{values: ['请选择','大巴', '飞机', '自驾', '高铁']}],
            buildslots: '',
            isDone:false,
            options:[
                {
                    label: '业主',
                    value: '业主',
                    disabled:true
                },
                {
                    label: '租户',
                    value: '租户',
                    disabled:true
                },
                {
                    label: '公司',
                    value: '公司',
                    disabled:true
                },
                {
                    label: '访客',
                    value: '访客',
                    disabled:true
                }
            ],
            options2:[
                {
                    label: '否',
                    value: '否',
                    disabled:true
                },
                {
                    label: '是',
                    value: '是',
                    disabled:true
                },
            ],
            userCard:{
                return_date:'',
                name:'',
                company:'',
                expire_time:'请选择',
                mobile:'',
                card:'',
                address:'',
                wuhan:'',
                remark:'',
                vehicle:'请选择',
                backup:'',
                status:'',
                owner:'',
                No:'请选择',
                other:null
            },
        }
    },
    created() {
        if(this.$route.query.type == 'user') {
            this.title = '个人信息'
            this.getInfo()
        }else{
            this.title = '信息详情'
            this.getPinfo()
        }
    },
    mounted() {
        
    },
    destroyed() {
        // localStorage.setItem("pass",'')
        localStorage.setItem("submitPass",'')
    },
    methods:{
        cancle() {
            this.showBtm = false
            this.userCard.vehicle = '请选择'
        },
        sure() {
            this.showBtm = false
        },
        cancle2() {
            this.showBuild = false
            this.userCard.No = '请选择'
        },
        sure2() {
            this.showBuild = false
        },
        getInfo() {
            // token:"l2O22owRc2BDRbRZBUHL2B2HDir25UR5",
                // poiId:'B000AB9AGW'
            // axios.get(this.commonIp()+`/v1/userCard/my?token=${this.getuserToken()}&poiId=B000A8W7I2`)
            axios.get(this.commonIp()+`/v1/userCard/my?token=${this.getuserToken()}&poiId=${this.$route.query.poiId}`)
            .then((res) => {
                if(res.data.code == '200') {
                    if(res.data.data.userCard!=null) {
                        this.allow = res.data.data.userCard.No
                        if(res.data.data.userCard.expire_time!='') {
                            let expireTimeDate = moment(res.data.data.userCard.expire_time, 'YYYY-MM-DD').toDate();
                            this.isDone = expireTimeDate.getTime() < moment().startOf('day').toDate().getTime()
                        }
                        if(res.data.data.userCard.return_date!='') {
                            this.isYes = '是'
                            this.showbackBox = true
                        }else{
                            this.isYes = '否'
                            this.showbackBox = false
                        }
                        if(res.data.data.userCard.status == '-1' || this.isDone) {
                            this.isDisable = false
                        }
                        this.userCard = res.data.data.userCard
                        // this.userCard.allowAddress = this.allow
                        if(this.userCard.status == '-1' || this.isDone) {
                            this.options = [
                                {
                                    label: '业主',
                                    value: '业主',
                                },
                                {
                                    label: '租户',
                                    value: '租户',
                                },
                                {
                                    label: '公司',
                                    value: '公司',
                                },
                                {
                                    label: '访客',
                                    value: '访客',
                                },
                            ]
                            this.options2 = [{
                                    label: '否',
                                    value: '否',
                                },
                                {
                                    label: '是',
                                    value: '是',
                                }]
                        }else{
                            this.options = [
                                {
                                    label: '业主',
                                    value: '业主',
                                    disabled:true
                                },
                                {
                                    label: '租户',
                                    value: '租户',
                                    disabled:true
                                },
                                {
                                    label: '公司',
                                    value: '公司',
                                    disabled:true
                                },
                                {
                                    label: '访客',
                                    value: '访客',
                                    disabled:true
                                },
                            ]
                            this.options2 = [{
                                    label: '否',
                                    value: '否',
                                    disabled:true
                                },
                                {
                                    label: '是',
                                    value: '是',
                                    disabled:true
                                }]
                        }
                    }
                }else{
                    Toast(res.data.message)
                }
            })
        },
        getPinfo() {
            // 没登录线条登陆
            axios.post(this.commonIp()+'/v1/userCard/userInfo',{
                token:this.getuserToken(),
                poiId:this.$route.query.poiId || '',
                openId:this.$route.query.openId || '',
                code:this.$route.query.code || '',
                _id:this.$route.query.id || '',
                // pass:localStorage.getItem("pass") || ''
                pass:localStorage.getItem("submitPass") || ''
            })
            .then((res) => {
                if(res.data.code == '424' || res.data.code == '423') {
                    if (this.isAndroid() || this.isIos()) {
                        window.location.href = "app://login";
                    } else {
                        // lng=116.467125&lat=39.996747
                        window.location.href = `${this.commonIp()}/quickLogin?referer=${encodeURIComponent(window.location.href)}`;
                    }
                }else if(res.data.code == '200') {
                    if(res.data.data.userCard!=null) {
                        if(res.data.data.userCard.return_date!='') {
                            this.isYes = '是'
                            this.showbackBox = true
                        }else {
                            this.isYes = '否'
                            this.showbackBox = false
                        }
                        this.userCard = res.data.data.userCard
                    }
                }else{
                    Toast(res.data.message)
                }
            })
        },
        test() {
            if(this.userCard.status == '-1' || this.isDone){
                this.showBtm = true
            }
        },
        chioceBuild() {
            if((this.userCard.status == '-1'  || this.isDone)){
                this.showBuild = true
            }
        },
        chioceTime() {
            if((this.userCard.owner=='租户'&&this.userCard.status == '-1') || (this.isDone)) {
                this.$refs.picker.open();
            }
        },
        chioceTime2() {
            if((this.isYes=='是'&&this.userCard.status == '-1') || (this.isDone)) {
                this.$refs.picker2.open();
            }
        },
        onValuesChange(index,value) {
            this.userCard.vehicle = value[0]
        },
        onValuesChange2(index,value) {
            this.userCard.No = value[0]
        },
        // 点击撤销
        cxSubmit() {
            MessageBox({
                title: '提示',
                confirmButtonText:'确定',
                message: '撤销后用户扫码将不再有通行证,进小区需要重新申请通行证',
                showCancelButton: true,
            }).then(action => {
                    if (action == 'confirm') {     //确认的回调
                        axios.post(this.commonIp()+'/v1/userCard/verify',{
                            token:this.getuserToken(),
                            status:'-1',
                            openId:this.$route.query.openId || '',
                            poiId: this.$route.query.poiId ,
                            _id:this.$route.query.id || '',
                            // pass:localStorage.getItem('pass') || ''
                            pass:localStorage.getItem('submitPass') || ''
                        }).then((res) => {
                            if(res.data.code=='200') {
                                // 审核通过后进入页面
                                this.$router.push({path:`/records?poiId=${this.$route.query.poiId}`})
                            }else{
                                Toast(res.data.message)
                            }
                        })
                    }
                }).catch(err => { 
                    if (err == 'cancel') {     //取消的回调
                    } 
            });
        },
        // 点击修改
        regSubmit() {
            // this.isDisable = false
            MessageBox({
                title: '提示',
                confirmButtonText:'确定',
                message: '确认让住户修改资料重新提交吗?',
                showCancelButton: true,
            }).then(action => {
                    if (action == 'confirm') {     //确认的回调
                        axios.post(this.commonIp()+'/v1/userCard/verify',{
                            token:this.getuserToken(),
                            status:'-1',
                            openId:this.$route.query.openId || '',
                            poiId: this.$route.query.poiId,
                            code:this.$route.query.code || '',
                            _id:this.$route.query.id || '',
                            // pass:localStorage.getItem('pass')||''
                            pass:localStorage.getItem('submitPass') || ''
                        }).then((res) => {
                            if(res.data.code=='200') {
                                // 审核通过后进入页面
                                this.$router.push({path:`/records?poiId=${this.$route.query.poiId}`})
                            }else{
                                Toast(res.data.message)
                            }
                        })
                    }
                }).catch(err => { 
                    if (err == 'cancel') {     //取消的回调
                    } 
            });
        },
        // 点击审核
        submitForm() {
            MessageBox({
                title: '提示',
                confirmButtonText:'确定',
                message: '确认通过该用户的审核信息吗?',
                showCancelButton: true,
            }).then(action => {
                    if (action == 'confirm') {     //确认的回调
                        axios.post(this.commonIp()+'/v1/userCard/verify',{
                            token:this.getuserToken(),
                            openId:this.$route.query.openId || '',
                            status:'1',
                            poiId: this.$route.query.poiId,
                            code:this.$route.query.code || '',
                            // pass:localStorage.getItem('pass')||''
                            pass:localStorage.getItem('submitPass') || ''
                        }).then((res) => {
                            if(res.data.code=='200') {
                                // 审核通过后进入页面
                                this.$router.push({path:`/records?poiId=${this.$route.query.poiId}`})
                            }else{
                                Toast(res.data.message)
                            }
                        })
                    }
                }).catch(err => { 
                    if (err == 'cancel') {     //取消的回调
                    } 
            });
        },
        // 点击提交
        changeSubmit() {
            if(!this.userCard.name) {
                Toast('请输入姓名');
            }else if(!this.userCard.mobile) {
                Toast('请输入手机号');
            }else if(!this.userCard.card) {
                Toast('请输入身份证号');
            }else if(!this.userCard.owner) {
                Toast('请选择身份');
            }else if(!this.userCard.address) {
                Toast('请输入地址');
            }else if(this.userCard.owner == '租户'&&!this.userCard.expire_time){
                Toast('请选择租赁截止日期');
            }else if(this.userCard.owner == '公司'&&!this.userCard.company){
                Toast('请输入公司名称');
            }else if(this.userCard.owner == '访客'&&!this.userCard.other){
                Toast('请输入事由');
            }else if(!this.isYes) {
                Toast('请选择十四天内是否返京');
            }else if(this.isYes=='是'&&!this.userCard.return_date){
                Toast('请选择返京时间');
            }else if(this.isYes=='是'&&!this.userCard.wuhan) {
                Toast('请输入从何地返京');
            }else{
                if(this.userCard.expire_time=='请选择'){
                    this.userCard.expire_time = ''
                }
                if(this.userCard.vehicle=='请选择'){
                    this.userCard.vehicle = ''
                }
                if(this.userCard.No=='请选择'){
                    this.userCard.No = ''
                }
                MessageBox({
                    title: '提示',
                    confirmButtonText:'确定提交',
                    message: '请确认信息填写无误后点击确认提交',
                    showCancelButton: true,
                }).then(action => {
                        if (action == 'confirm') {     //确认的回调
                            if(this.userCard.owner=='访客') {
                                this.userCard.expire_time = ''
                            }
                            axios.post(this.commonIp()+'/v1/userCard',{
                                token:this.getuserToken(),
                                poiId:this.$route.query.poiId,
                                name:this.userCard.name,
                                mobile:this.userCard.mobile,
                                card:this.userCard.card.trim(),
                                address:this.userCard.address,
                                wuhan:this.userCard.wuhan,
                                backup:this.userCard.backup,
                                vehicle:this.userCard.vehicle,
                                owner:this.userCard.owner,
                                expire_time:this.userCard.expire_time,
                                No:this.userCard.No,
                                company:this.userCard.company,
                                return_date:this.userCard.return_date,
                                other:this.userCard.other
                            }).then((res) => {
                                if(res.data.code == '200') {
                                    axios.get(this.commonIp()+`/v1/userCard/my?token=${this.getuserToken()}&poiId=${this.$route.query.poiId}`)
                                        .then((res) => {
                                            if(res.data.code == '200') {
                                                this.$router.push({path:`/pcheck?poiId=${this.$route.query.poiId}`})
                                            }else{
                                                Toast(res.data.message)
                                            }
                                        })
                                }else{
                                    Toast(res.data.message)
                                }
                            })
                        }
                    }).catch(err => {
                        console.log(err)
                        if (err == 'cancel') {     //取消的回调
                        
                        } 
                });
            }
        },
        chioceVal2(val){
            this.isYes = val
            if(val == '是') {
                this.showbackBox = true
            }else{
                this.showbackBox = false
                this.userCard.return_date = ''
                this.userCard.wuhan = ''
                this.userCard.vehicle = ''
                this.userCard.backup = ''
            }
            if(this.userCard.status == '-1' || this.isDone) {
                this.options2 = [
                    {
                        label: '否',
                        value: '否',
                    },
                    {
                        label: '是',
                        value: '是',
                    }
                ]
            }else{
                this.options2 = [
                    {
                        label: '否',
                        value: '否',
                        disabled:true
                    },
                    {
                        label: '是',
                        value: '是',
                        disabled:true
                    }
                ]
            }
        },
        chioceVal(val) {
            if(val!='租户') {
                this.userCard.expire_time = '请选择'
            }
            if(val !='公司') {
                this.userCard.company = ''
            }
            if(val !='访客') {
                this.userCard.other = ''
            }
            if(this.userCard.status == '-1' || this.isDone) {
                this.options = [
                    {
                        label: '业主',
                        value: '业主',
                    },
                    {
                        label: '租户',
                        value: '租户',
                    },
                    {
                        label: '公司',
                        value: '公司',
                    },
                    {
                        label: '访客',
                        value: '访客',
                    }
                ]
                this.userCard.owner = val
            }else{
                this.options = [
                    {
                        label: '业主',
                        value: '业主',
                        disabled:true
                    },
                    {
                        label: '租户',
                        value: '租户',
                        disabled:true
                    },
                    {
                        label: '公司',
                        value: '公司',
                        disabled:true
                    },
                    {
                        label: '访客',
                        value: '访客',
                        disabled:true
                    }
                ]
            }
        },
        getTimeval(val) {
            this.userCard.expire_time = moment(val.getTime()).format('YYYY-MM-DD')
        },
        getTimeval2(val) {
            this.userCard.return_date = moment(val.getTime()).format('YYYY-MM-DD')
        }
    }
}
</script>
<style lang="less">

    @import "~@/assets/less/index.less";
    .adarea{
        .mint-field-core{
            line-height: auto;
        }
    }
    .mint-msgbox-confirm{
        color:#23b355;
        border-left:1px solid #eee;
    }
    .mint-msgbox-message{
        line-height: 20px;
    }
    #xxDetail{
        .mint-field-core{
            font-size:17px;
        }
        .mint-datetime-action{
            color:#25cf8d;
        }
        .mint-cell-text{
            font-size:17px;
        }
        .chiceBox{
            width:100%;
            height: 100%;
            position: fixed;
            top:0;
            background:rgba(0,0,0,.5);
            z-index:99;
            .innerBox{
                padding:0 0 30px;
                background:#fff;
                position: absolute;
                bottom:0;
                width:100%;
                .btns{
                    margin-top:30px;
                    text-align: center;
                    a{
                        padding:8px 40px;
                        text-align: center;
                        display: inline-block;
                        background:#eee;
                        border-radius:5px;
                        color:#25cf8d;
                        &.sure{
                            margin-left:10px;
                            background:#25cf8d;
                            color:#fff;
                        }
                    }
                }
            }
        }
        .addTag{
            position: relative;
            .mint-cell-title::after{
                color:red;
                content:'*';
                display: inline-block;
                vertical-align: bottom;
            }
        }
        .rowItem{
            padding:0 15px;
            border-top:1px solid #eee;
            border-bottom:1px solid #eee;
            line-height: 48px;
            &.sfRow{
                padding-right:10px;
                &.mint-cell{
                    width:71px;
                }
                .mint-radio-label{
                    margin-left:0;
                }
                .mint-radio-label{
                    font-size:16px;
                }
            }
            &.rowItem1{
                border-bottom: 0 none;
                padding-left:15px;
            }
            i{
                color:red;
                font-style: normal;
            }
            .clearfix();
            span{
                .fr();
                font-size: 17px;
                color: #666;
            }
            .name{
                .fl();
                color:#000;
                font-size:17px;
            }
            .mint-radio-core{
                width: 18px;
                height: 18px;
                margin-left:2px;
            }
            .mint-radio-input:checked + .mint-radio-core{
                background:#25cf8d;
                border-color:#25cf8d;
                width:18px;
                height: 18px;
                &::after{
                    top:4px;
                    left:4px;
                }
            }
            .radios{
                .fr();
                .mint-cell-wrapper{
                    padding:0;
                    border-bottom:0;
                }
                .mint-cell{
                    .fl();
                    border-top:0;
                    border-bottom:0;
                }
                .mint-radiolist-title{
                    display: none;
                }
            }
        }
        .setFix{
            border:0;
        }
        .submitBtn{
            width:43%;
            &.ssubmitBtn{
                background:orange;
            }
            &.cxBtn{
                background:red;
            }
            &.dsubmitBtn{
                right:5%;
                left:auto;
            }
        }
        .mint-msgbox-header{
            display: none !important;
        }
        .mint-cell{
            border-top:1px solid #eee;
            .mint-cell-wrapper{
                background-image:none;
                padding:0 16px;
            }
            .mint-field-core{
                background:#fff;
            }
            &:last-child{
                background-image:none;
                border-bottom:1px solid #eee;
            }
            .mint-cell-value{
                font-size:@ft14;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/xxdetail/xxdetail.vue